import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { confirmAlert } from 'react-confirm-alert';

/* MODAL */
import { useModal } from 'hooks/modalContext';
import CloseBtn from 'components/util/CloseModal';

/* JS */
import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';

const WarehousingModal = props => {
  const { closeModal } = useModal();

  const [item, setItem] = useState([{
    productSeq: 0,
    fkProductType: '',
    fkProductKind: '',
    fkWarehouse: '',
    productName: '',
    fkProductUnit: '',
    productStatus: 'I',
    regDate: '',
    defaultQuantity: 0,
  }]);
  const [isData, setIsData] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [productType, setProductType] = useState([]);
  const [productKind, setProductKind] = useState([]);
  const [warehouse, setWarehouse] = useState([]);
  const [productUnit, setProductUnit] = useState([]);

  useEffect(() => {
    Server.sendGet('product/type', {}, getProductTypeList).then();
    Server.getCommonCode('ProductKind', getProductKindList).then();
    Server.getCommonCode('WAREHOUSE', getWarehouseList).then();
    Server.getCommonCode('ProductUnit', getProductUnitList).then();
  }, []);

  useEffect(() => {
    if (!props.props?.isRegi && !isData) {
      setItem(props.props?.data.item);
      setIsData(true);
    }
  }, [props]);

  const getProductTypeList = res => {
    setProductType(res['resultList']);
  };

  const getProductKindList = res => {
    setProductKind(res['resultList']);
  };

  const getWarehouseList = res => {
    setWarehouse(res['resultList']);
  };

  const getProductUnitList = res => {
    setProductUnit(res['resultList']);
  };

  const validation = () => {
    const msgArr = [
      'Type required.',
      'Kind required.',
      'Warehouse required.',
      'Name required.',
      'Quantity required.',
      'Unit required.',
    ];
    const columns = [
      'fkProductType',
      'fkProductKind',
      'fkWarehouse',
      'productName',
      'defaultQuantity',
      'fkProductUnit',
    ];

    for (let i = 0; i < columns.length; i++) {
      if (Common.isEmpty(item[columns[i]])) {
        Common.errorMsg(msgArr[i]);

        return false;
      }
    }

    return true;
  };

  const productWarehousing = () => {
    if (validation() && !isSubmit) {
      confirmAlert({
        title: 'Are you sure you want to save?',
        buttons: [{
          label: 'Yes',
          onClick: () => {
            setIsSubmit(true);

            Server.sendPost('product/mst', item, productWarehousingCallback).then();
          }
        }, {
          label: 'No'
        }]
      });
    }
  };
  
  const productWarehousingCallback = () => {
    setIsSubmit(false);

    props.props.data.callback();

    Common.alertSuccess();

    closeModal();
  };

  return (
    <>
      <CloseBtn onClick={closeModal}/>

      <div className='modal-box'>
        <div className='inner'>
          <Title>
            <TitHead>
              <i/>
              <h4>Product Warehousing {props.props?.isRegi ? 'Registration' : 'Modify'}</h4>
            </TitHead>
          </Title>
          <ModalForm>
            <FormIn>
              <FormInWrap>
                <label><span>* </span>Product Type</label>
                <select
                  name='productType'
                  id='productType'
                  value={item?.fkProductType || ''}
                  onChange={e => {
                    setItem(() => {
                      return {
                        ...item,
                        fkProductType: e.target.value,
                      };
                    });
                  }}
                >
                  <option value={''}>-- Select --</option>
                  {productType.map(v => (
                    <option key={v.productTypeMstSeq} value={v.productTypeMstSeq}>{v.productType}</option>
                  ))}
                </select>
              </FormInWrap>
              <FormInWrap>
                <label><span>* </span>Product Kind</label>
                <select
                  name='productKind'
                  id='productKind'
                  value={item?.fkProductKind || ''}
                  onChange={e => {
                    setItem(() => {
                      return {
                        ...item,
                        fkProductKind: e.target.value,
                      };
                    });
                  }}
                >
                  <option value={''}>-- Select --</option>
                  {productKind.map(v => (
                    <option key={v['codeValue']} value={v['codeValue']}>{v['codeName']}</option>
                  ))}
                </select>
              </FormInWrap>
            </FormIn>
            <FormIn>
              <FormInWrap>
                <label><span>* </span>Storage warehouse</label>
                <select
                  name='warehouse'
                  id='warehouse'
                  value={item?.fkWarehouse || ''}
                  onChange={e => {
                    setItem(() => {
                      return {
                        ...item,
                        fkWarehouse: e.target.value,
                      };
                    });
                  }}
                >
                  <option value={''}>-- Select --</option>
                  {warehouse.map(v => (
                    <option key={v['codeValue']} value={v['codeValue']}>{v['codeName']}</option>
                  ))}
                </select>
              </FormInWrap>
              <FormInWrap>
                <label><span>* </span>Product Name</label>
                <FormInput
                  type='text'
                  id='productName'
                  name='productName'
                  value={item?.productName}
                  onChange={e => {
                    setItem(() => {
                      return {
                        ...item,
                        productName: e.target.value,
                      }
                    });
                  }}
                />
              </FormInWrap>
            </FormIn>
            <FormIn>
              <FormInWrap>
                <label><span>* </span>Quantity</label>
                <FormInput
                  type='text'
                  id='quantity'
                  name='quantity'
                  value={item?.defaultQuantity || 0}
                  onChange={e => {
                    e.target.value = Common.onlyNumber(e.target.value);

                    setItem(() => {
                      return {
                        ...item,
                        defaultQuantity: parseInt(e.target.value),
                      }
                    });
                  }}
                />
              </FormInWrap>
              <FormInWrap>
                <label><span>* </span>Unit</label>
                <select
                  name='productUnit'
                  id='productUnit'
                  value={item?.fkProductUnit || ''}
                  onChange={e => {
                    setItem(() => {
                      return {
                        ...item,
                        fkProductUnit: e.target.value,
                      };
                    });
                  }}
                >
                  <option value={''}>-- Select --</option>
                  {productUnit.map(v => (
                    <option key={v['codeValue']} value={v['codeValue']}>{v['codeName']}</option>
                  ))}
                </select>
              </FormInWrap>
            </FormIn>
            <FormBtn $Btn>
              <Btn onClick={closeModal}>Cancel</Btn>
              <Btn $Color onClick={productWarehousing}>Submit</Btn>
            </FormBtn>
          </ModalForm>
        </div>
      </div>
    </>
  );
}

const Title = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0 10px;

  & i {
    display: block;
    width: 4px;
    height: 32px;
    border-radius: 0 2px 2px 0;
    background: #1e1e1e;
  }

  & h4 {
    font-weight: 700;
    font-size: 18px;
    color: #000000;
  }
`;

const ModalForm = styled.div`
  margin-top: 20px;
  position: relative;
  border-top: 1px solid #eeeeee;

  & > div + div {
    margin-top: 10px;
  }
`;

const FormIn = styled.div`
  display: flex;
  gap: 10px 20px;

  & select {
    width: calc(70% - 10px);
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    background: #f8f8f8 url('https://ust-india.s3.ap-northeast-2.amazonaws.com/erp-web/sel_arrow.svg') top 50% right 10px no-repeat;
    border: 1px solid #cccccc;
    border-radius: 5px;
    outline: none;
    font-weight: 400;
    font-size: 16px;
    color: #000000;

    &:focus {
      border-color: #0072B9;
    }
  }

  & textarea {
    width: calc(70% - 10px);
    height: 150px;
    padding: 10px 16px;
    background: #f8f8f8;
    border-radius: 5px;
    border: 1px solid #cccccc;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    resize: none;
    outline: none;

    &:focus {
      border-color: #0072B9;
    }
  }
`;

const FormInWrap = styled.div`
  display: inline-flex;
  width: 50%;
  align-items: center;
  gap: 0 10px;
  float: left;
  height: 60px;

  & label {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
    width: 30%;

    & span {
      font-size: 11px;
      color: red;
    }
  }
`;

const FormInput = styled.input`
  width: calc(70% - 10px);
  height: 40px;
  line-height: 40px;
  padding: 0 16px;
  background: #f8f8f8;
  border: 1px solid #cccccc;
  border-radius: 5px;
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  outline: none;

  &:focus {
    border-color: #0072B9;
  }
`;

const FormBtn = styled.div`
  margin-top: 25px !important;
  display: flex;
  align-items: center;
  gap: 0 8px;
`;

const Btn = styled.button`
  flex: 1;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: ${props => (props['$Color'] ? '#0072b9' : '#a4a4a4')};
  font-weight: 500;
  font-size: 18px;
  color: #ffffff;
  text-align: center;

  &:hover {
    background-color: ${props => (props['$Color'] ? '#075C97' : '#7e7e7e')};
  }
`;

export default WarehousingModal;